import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Index, Configure } from 'react-instantsearch-dom';
import { Container, Heading } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import ConnectedHits from './ConnectedHits/ConnectedHits.js';

function NoSearchResults(_param) {
    var { className , indexName , query =''  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "indexName",
        "query"
    ]);
    const { getFormattedLabel , getLabel  } = useIntl();
    if (!indexName) return null;
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({
        className: classnames('no-search-results', className)
    }, rest), /*#__PURE__*/ React.createElement(Container, null, /*#__PURE__*/ React.createElement(Heading, {
        variant: "medium"
    }, getFormattedLabel('search.noResults.resultsFor', {
        labelData: {
            query
        }
    })), /*#__PURE__*/ React.createElement(Heading, {
        color: "text-secondary",
        component: "p",
        variant: "small"
    }, getLabel('search.noResults.checkSpelling')), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Index, {
        indexName: indexName
    }, /*#__PURE__*/ React.createElement(Configure, {
        query: "",
        length: 10
    }), /*#__PURE__*/ React.createElement(ConnectedHits, {
        indexName: indexName,
        title: getLabel('search.noResults.alternativeQueries')
    })))));
}

export { NoSearchResults as default };
//# sourceMappingURL=NoSearchResults.js.map
